import { render } from "./AssociatedDoctorModal.vue?vue&type=template&id=3b31aaa4&scoped=true"
import script from "./AssociatedDoctorModal.vue?vue&type=script&lang=js"
export * from "./AssociatedDoctorModal.vue?vue&type=script&lang=js"

import "./AssociatedDoctorModal.vue?vue&type=style&index=0&id=3b31aaa4&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b31aaa4"]])

export default __exports__